import { z } from "zod";

// company profile schema
export const companyProfileSchema = z.object({
  website_url: z
    .string()
    .optional()
    .transform((val) => {
      if (!val || typeof val !== "string") return "";
      return val
        .replace(/^https?:\/\//, "")
        .replace(/^www\./, "")
        .replace(/\/.*$/, "")
        .trim();
    })
    .refine(
      (val) =>
        val === "" ||
        /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/.test(
          val,
        ),
      "Invalid domain. Use format: example.com",
    ),
  description: z.string().min(1, "Description is required."),
  services: z.array(z.string().min(1)).min(1, "Add at least one service."),
});

/** New user onboarding: website only — same normalisation + domain check as company profile. */
export const newUserWebsiteUrlSchema = z.object({
  website_url: z
    .string()
    .trim()
    .min(1, "Please enter your company website URL.")
    .transform((val) => {
      if (!val || typeof val !== "string") return "";
      return val
        .replace(/^https?:\/\//i, "")
        .replace(/^www\./i, "")
        .replace(/\/.*$/, "")
        .trim();
    })
    .refine(
      (val) =>
        val.length > 0 &&
        /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/.test(
          val,
        ),
      "Invalid domain. Use format: example.com",
    ),
});

// define pitch schema
export const definePitchSchema = z.object({
  pain_points_solved: z
    .string()
    .min(10, { message: "Please describe at least one pain point." })
    .max(1000, { message: "Keep it under 1000 characters." }),

  value_proposition: z
    .string()
    .min(10, {
      message: "Value proposition should be at least 10 characters long.",
    })
    .max(1000, { message: "Keep it under 1000 characters." }),

  company_level_trigger: z.array(z.any()),

  industry_level_trigger: z.array(z.any()),

  signal_trigger_config: z.any().optional(),
});

// define audience schema
export const defineAudienceSchema = z.object({
  company_size: z.array(z.string()).min(1, "Select at least one company size"),
  target_industries: z
    .array(z.string())
    .min(1, "Select at least one industry"),
  roles: z.array(z.string()).min(1, "Select at least one role"),
  business_locations: z.array(z.string()).min(1, "Add at least one location"),
  ideal_customer: z
    .string()
    .min(1, "Please describe your ideal customer")
    .max(500, "Keep it under 500 characters"),
});

// train the trainer UI
export const emailSchema = z.object({
  user_sample_emails: z
    .array(z.string().email("Invalid email address"))
    .max(3, "No more than 3 emails allowed"),

  trained_sample_email: z.array(
    z.object({
      subject: z.string(),
      email: z.string()
    })
  )
});

// campaign form schema
export const campaignFormSchema = z.object({
  campaignName: z
    .string()
    .min(1, "Campaign name is required")
    .max(100, "Campaign name must be less than 100 characters"),
  selectedServices: z
    .array(z.string())
    .min(1, "Please select at least one service"),
});
